import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6138c57f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column is-4" }
const _hoisted_2 = { class: "column is-3" }
const _hoisted_3 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometro = _resolveComponent("Cronometro")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "columns clicavel",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tarefaClicada && _ctx.tarefaClicada(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tarefa.descricao || 'Tarefa sem descrição'), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tarefa.projeto?.nome || 'N/D'), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Cronometro, {
            tempoEmSegundos: _ctx.tarefa.duracaoEmSegundos
          }, null, 8, ["tempoEmSegundos"])
        ])
      ])
    ]),
    _: 1
  }))
}